var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:['full-icon-button', _vm.emphasis],on:{"click":function($event){return _vm.$emit('click', $event)}}},[(_vm.icon)?_c('svgicon',{staticClass:"icon",attrs:{"icon":_vm.icon}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }